import {combineReducers} from "redux";
import branchesState from './branch/reducers';
import expenseTypesState from './expense_type/reducers';
import incomeTypesState from './income_type/reducers';

export default combineReducers({branchesState, expenseTypesState, incomeTypesState});